export default "__VITE_ASSET__GldwhM$e__"